import { MerlinActionTypes } from './merlin.types';

const requestMerlinToken = () => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN });
const merlinTokenSuccess = token => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN_SUCCESS, payload: { token } });
const merlinTokenFail = () => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN_FAIL });
const merlinSetUrl = url => ({ type: MerlinActionTypes.MERLIN_SET_URL, payload: { url } });
const setChatData = ({ chatId, cookieName, isIframeOpen }) => ({ type: MerlinActionTypes.MERLIN_SET_CHAT_DATA, payload: { chatId, cookieName, isIframeOpen } });
const setMigrationData = ({ hostingId, domain, type }) => ({ type: MerlinActionTypes.MERLIN_SET_MIGRATION_DATA, payload: { hostingId, domain, type } });
const merlinReset = () => ({ type: MerlinActionTypes.MERLIN_RESET });

const setMessage = response => ({
  type: MerlinActionTypes.POC_SET_RESPONSE,
  payload: {
    response,
  },
});

const sendAudioMessage = payload => ({
  type: MerlinActionTypes.SEND_AUDIO_MESSAGE,
  payload,
});

const setLoadingTranscription = isLoading => ({
  type: MerlinActionTypes.SET_LOADING_TRANSCRIPTION,
  payload: isLoading,
});

const setTranscriptionError = () => ({
  type: MerlinActionTypes.SET_TRANSCRIPTION_ERROR,
});

const getAudioTranscription = ({ result }) => ({
  type: MerlinActionTypes.GET_AUDIO_TRANSCRIPTION,
  payload: {
    result,
  },
});

const clearAudioTranscription = () => ({
  type: MerlinActionTypes.GET_AUDIO_TRANSCRIPTION,
  payload: {
    result: '',
  },
});


const renderInHouseChat = bool => ({
  type: MerlinActionTypes.POC_RENDER_INHOUSE_CHAT,
  payload: bool,
});

const minimizeInHousechat = bool => ({
  type: MerlinActionTypes.POC_MINIMIZE_INHOUSE_CHAT,
  payload: bool,
});

const visibilityInHousechat = bool => ({
  type: MerlinActionTypes.POC_VISIBILITY_INHOUSE_CHAT,
  payload: bool,
});

const rateMessage = ({
  url,
  env,
  threadId,
  accountId,
  token,
  messageId,
  rating,
  apiAuthKey,
  brandName,
  ratedMessages,
}) => ({
  type: MerlinActionTypes.AI_CHAT_RATE_MESSAGE,
  payload: {
    url,
    env,
    threadId,
    accountId,
    token,
    messageId,
    rating,
    apiAuthKey,
    brandName,
    ratedMessages,
  },
});

const rateChat = ({
  url,
  env,
  threadId,
  token,
  rating,
  ratingMessage,
  brandName,
}) => ({
  type: MerlinActionTypes.RATE_AI_CHAT,
  payload: {
    url,
    env,
    threadId,
    token,
    rating,
    ratingMessage,
    brandName,
  },
});

const successRateMessage = response => ({
  type: MerlinActionTypes.AI_CHAT_RATE_MESSAGE_SUCCESS,
  payload: {
    response,
  },
});

const failureRateMessage = error => ({
  type: MerlinActionTypes.AI_CHAT_RATE_MESSAGE_FAILURE,
  payload: {
    error,
  },
});

const setCurrentChatState = payload => ({
  type: MerlinActionTypes.AICHAT_SET_CHAT_STATE,
  payload,
});

const toggleFullScreen = isFullscreen => ({
  type: MerlinActionTypes.TOGGLE_FULLSCREEN,
  payload: isFullscreen,
});

const setMaiaAgent = agent => ({
  type: MerlinActionTypes.SET_MAIA_AGENT,
  payload: agent,
});

const setSideContent = ({ isOpen, url }) => ({
  type: MerlinActionTypes.SET_SIDE_CONTENT,
  payload: { isOpen, url },
});

const resetSideContent = () => ({
  type: MerlinActionTypes.RESET_SIDE_CONTENT,
});

const setExternalMessage = message => ({
  type: MerlinActionTypes.SET_EXTERNAL_MESSAGE,
  payload: message,
});

const setExternalAudioBlob = blob => ({
  type: MerlinActionTypes.SET_EXTERNAL_AUDIO_BLOB,
  payload: blob,
});

const generateThreadId = () => ({
  type: MerlinActionTypes.GENERATE_THREAD_ID,
});

const setRoute = route => ({
  type: MerlinActionTypes.SET_ROUTE,
  payload: route,
});

const redirectToBrizy = payload => ({
  type: MerlinActionTypes.REDIRECT_TO_BRIZY,
  payload,
});

const executeN8nLoading = bool => ({
  type: MerlinActionTypes.EXECUTE_N8N_LOADING,
  payload: bool,
});

const requestAlerts = () => ({
  type: MerlinActionTypes.AI_REQUEST_ALERTS,
});

const setAlerts = ({ alert }) => ({
  type: MerlinActionTypes.AI_SET_ALERTS,
  payload: { alert },
});

const loadingAlerts = bool => ({
  type: MerlinActionTypes.AI_LOADING_ALERTS,
  payload: bool,
});

const showAlerts = bool => ({
  type: MerlinActionTypes.AI_SHOW_ALERTS,
  payload: bool,
});

const removeAlerts = ({
  delay, alerts, nonRemovableTitle, unDoAction, undo,
}) => ({
  type: MerlinActionTypes.AI_REMOVE_ALERTS,
  payload: {
    delay, alerts, nonRemovableTitle, unDoAction, undo,
  },
});

const getAlertsTypes = () => ({
  type: MerlinActionTypes.AI_GET_ALERTS_TYPES,
});

const loadingAlertsTypes = bool => ({
  type: MerlinActionTypes.AI_LOADING_ALERTS_TYPES,
  payload: bool,
});

const setAlertsTypes = ({ alertsTypes }) => ({
  type: MerlinActionTypes.AI_SET_ALERTS_TYPES,
  payload: { alertsTypes },
});

const requestAlertPerSlug = ({ slug }) => ({
  type: MerlinActionTypes.AI_REQUEST_ALERT_PER_SLUG,
  payload: { slug },
});

const setLoadingBySlug = ({ slug, loading }) => ({
  type: MerlinActionTypes.AI_SET_LOADING_BY_SLUG,
  payload: { slug, loading },
});

const setMessageFromRequest = message => ({
  type: MerlinActionTypes.SET_MESSAGE_FROM_REQUEST,
  payload: message,
});

const setWithMultiAgent = () => ({
  type: MerlinActionTypes.ACTION_WITH_MULTI_AGENT,
});

const setWithN8n = () => ({
  type: MerlinActionTypes.ACTION_WITH_N8N,
});

const merlinActions = {
  requestMerlinToken,
  merlinTokenSuccess,
  merlinTokenFail,
  merlinSetUrl,
  merlinReset,
  setChatData,
  setMigrationData,
  inhouse: {
    renderInHouseChat,
    minimizeInHousechat,
    visibilityInHousechat,
    sendAudioMessage,
    setLoadingTranscription,
    getAudioTranscription,
    clearAudioTranscription,
    setTranscriptionError,
    setMessage,
    rateMessage,
    successRateMessage,
    failureRateMessage,
    setCurrentChatState,
    toggleFullScreen,
    setMaiaAgent,
    setSideContent,
    resetSideContent,
    setExternalMessage,
    generateThreadId,
    setRoute,
    setExternalAudioBlob,
    setMessageFromRequest,
  },
  redirectToBrizy,
  executeN8nLoading,
  rateChat,
  alerts: {
    requestAlerts,
    loadingAlerts,
    setAlerts,
    showAlerts,
    removeAlerts,
    getAlertsTypes,
    loadingAlertsTypes,
    setAlertsTypes,
    requestAlertPerSlug,
    setLoadingBySlug,
  },
  setWithMultiAgent,
  setWithN8n,
};

export default merlinActions;
